export default [
    {
        path: '/companies',
        name: 'companies',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Empresas',
            icon: 'mdi-barn',
            breadcrumbs: [
                { text: 'Lista de empresas', disabled: true }
            ]
        }
    }
]